// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Numeric } from 'common/components/Number';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const SamplingWrapper = styled.div`
  margin-right: ${({ theme }) => theme.metrics.margin}px;
`;

const TooltipWrapper = styled.div`
  color: ${({ theme }) => theme.colors.hexToRGBA(theme.fonts.style.small.color, 0.8)};
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  font-family: ${({ theme }) => theme.fonts.style.small.fontFamily}px;
`;

type Props = {
  sampling: { total: number, listening: number },
  hideTotal?: boolean,
  t: any,
}

function Sampling(props: Props) {
  const { t, hideTotal, sampling: { total, listening } } = props;

  return (
    <div>
      <Wrapper>
        {!hideTotal &&
          <SamplingWrapper>
            {t('sampling.total')} <Numeric value={total} roundAt={0} />{'*'}
          </SamplingWrapper>}
        <SamplingWrapper>{t('sampling.listening')} <Numeric value={listening} roundAt={0} /></SamplingWrapper>
      </Wrapper>
      {!hideTotal &&
        <div className="row">
          <SamplingTooltip />
        </div>}
    </div>
  );
}

function Tooltip({ children, t }: { children?: any, t: any }) {
  return <TooltipWrapper>* {t('sampling.totalTooltip')}</TooltipWrapper>;
}

export const SamplingTooltip = translate('commonSales')(Tooltip);
export default translate('commonSales')(Sampling);



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/estimation/Sampling.js